import { put } from '..';

const editUser = (
  email: string,
  firstName: string,
  lastName: string,
  isAdmin?: boolean,
  roleId?: string,
) => put(
  `users/v3/${email}`,
  {
    firstName,
    lastName,
    ...(isAdmin !== undefined) && { isAdmin },
    ...(roleId !== undefined) && { roleId },
  },
);

export default editUser;
